import { KeyOption, matchSorter, rankings } from 'match-sorter';
import { OmnibarEntry } from '../omnibar-interfaces';

const mostUsedGroup = 'Oftest brugt';

// Capping keyword matches keeps a hit on the name ahead of a hit on a synonym.
const keywordsKey: KeyOption<OmnibarEntry> = { key: 'keywords', maxRanking: rankings.CONTAINS };

interface FilterState {
  inputValue: string;
}

function sortByGroup(options: OmnibarEntry[]) {
  return [...options].sort((a, b) => {
    const groupA = a.group ?? '';
    const groupB = b.group ?? '';

    if (groupA === mostUsedGroup && groupB !== mostUsedGroup) {
      return -1;
    }
    if (groupA !== mostUsedGroup && groupB === mostUsedGroup) {
      return 1;
    }

    const groupComparison = groupA.localeCompare(groupB);

    if (groupComparison !== 0) {
      return groupComparison;
    }

    return a.label.localeCompare(b.label);
  });
}

export function relevanceFilterOptions(options: OmnibarEntry[], { inputValue }: FilterState, searchKeywords = false) {
  if (!inputValue) {
    return sortByGroup(options);
  }

  const keys: KeyOption<OmnibarEntry>[] = searchKeywords ? ['label', 'group', keywordsKey] : ['label', 'group'];
  const rankedOptions = matchSorter(options, inputValue, { keys });

  // MUI's groupBy needs options from the same group to be adjacent, so order groups
  // by their best-ranked entry and keep the relevance order within each group.
  const groupRank = new Map<string, number>();
  rankedOptions.forEach((option, index) => {
    const group = option.group ?? '';
    if (!groupRank.has(group)) {
      groupRank.set(group, index);
    }
  });

  return rankedOptions.sort((a, b) => {
    const groupA = a.group ?? '';
    const groupB = b.group ?? '';

    if (groupA === groupB) return 0;
    if (groupA === mostUsedGroup) return -1;
    if (groupB === mostUsedGroup) return 1;
    return (groupRank.get(groupA) ?? 0) - (groupRank.get(groupB) ?? 0);
  });
}
